<question [title]="title" [description]="description" [valueOnly]="valueOnly">
  <ion-textarea class="input" [placeholder]="placeholder ? placeholder : ('DIALOGS.FREETEXT_PLACEHOLDER' | translate)" [(ngModel)]="value" [readonly]="valueOnly" (ionChange)="valueChanged()" (ionInput)="valueChanged()" *ngIf="!valueOnly" [rows]="rows">
  </ion-textarea>
  <div *ngIf="valueOnly">
    {{value}}
  </div>
</question>
